import { type FC } from 'react';

interface Props {
  percent: number;
}

export const ReturnInPercentText: FC<Props> = ({ percent }) => {
  return (
    <span className="font-details-demibold">{`${percent.toFixed(2)} %`}</span>
  );
};
